/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { Button, Col, Form, Input, Row, Space, Typography } from "antd";
import Heading from "components/Common/Heading/Heading";
import "./ForgotPassword.scss";
import { forgotPassword } from "api/services/userAuth.api";
import { notificationController } from "components/Common/Notification/Notification";
import { useNavigate } from "react-router-dom";
import { ForgotPasswordFormValues } from "interfaces/ApiInterface/ILoginFormData";
import { useAppSelector } from "hooks/reduxHooks";
import { ROUTES_PATH } from "routes/Routes.Constant";

const { Text } = Typography;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const localPortalData: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  const onFinish = async (values: ForgotPasswordFormValues) => {
    setLoading(true);

    const portalId = localPortalData?.lockerPortalDetails?.PortalId || null;
    const baseUrl = window.location.origin;
    const data = {
      PortalId: portalId,
      UserName: values?.username,
      User: {
        UserName: values?.username,
        Email: values?.username,
      },
      BaseUrl: baseUrl,
    };

    forgotPassword(data)
      .then(() => {
        notificationController.success({
          message: "Password reset email sent.",
        });
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.ErrorMessage || "An unexpected error occurred.";
        const notFoundMessage = `${values?.username} This user name is  not available.`;
        notificationController.error({
          message:
            notFoundMessage === errorMessage ? "Username/Email does not exist." : errorMessage,
        });
        setLoading(false);
        throw error;
      });
  };

  // Handler for canceling login and navigating back to home page
  const handleCancel = () => {
    navigate(ROUTES_PATH.LOGIN);
  };

  return (
    <div className="page-content-wrapper p-30">
      <Row gutter={15} className="global-form-container">
        <Col span={12} xs={24} md={12} xxl={12} lg={12}>
          <Heading titleText="Create Your Password" titleClass="global-form-heading" />
          <Text className="new-registration-info">
            Submit your Username below and we will send you a special link to your Email Address to
            create your password.
          </Text>
          <div className="form-wrapper mt-3">
            <Form
              layout="vertical"
              name="forgotPassword"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    Username/Email <span className="text-danger">*</span>
                  </span>
                }
                name="username"
                rules={[
                  { required: true, message: "Username/Email address is required." },
                  { type: "email", message: "Please enter a valid Username/Email address." },
                ]}
                className="input-label"
              >
                <Input className="form-input" />
              </Form.Item>
              <Form.Item className="global-form-action">
                <Space size={"middle"}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    className={isLoading ? "btn-disabled submit-request-btn" : "submit-request-btn"}
                  >
                    Submit Request
                  </Button>
                  <Button className="cancel-btn" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPassword;
